module.exports = {
	trueFunc: function trueFunc(){
		return true;
	},
	falseFunc: function falseFunc(){
		return false;
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/boolbase/index.js
// module id = 68
// module chunks = 0